import { render, staticRenderFns } from "./ProductAxBCutoff.vue?vue&type=template&id=58449902&scoped=true"
import script from "./ProductAxBCutoff.vue?vue&type=script&lang=js"
export * from "./ProductAxBCutoff.vue?vue&type=script&lang=js"
import style0 from "./ProductAxBCutoff.vue?vue&type=style&index=0&id=58449902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58449902",
  null
  
)

export default component.exports